import { isSection } from '../ListBoxBase/Item/utils';
import { cn } from '../../lib/css/className/className';

import { MenuItem, MenuItemLink, MenuItemOption, MenuItemSection, MenuItemSubMenu } from './types';

export const cnMenu = cn('Menu');
export const cnMenuItem = cn('MenuItem');

export function getMenuItemKey<ValueType extends string, SectionType extends string>(
    item: MenuItem<ValueType, SectionType>,
): ValueType | SectionType {
    return isMenuOption(item) ? item.value : item.key;
}

export function isMenuOption<ValueType extends string>(item: MenuItem<ValueType>): item is MenuItemOption<ValueType> {
    return 'value' in item;
}

export function isMenuLink<ValueType extends string>(item: MenuItem<ValueType>): item is MenuItemLink<ValueType> {
    return 'url' in item;
}

export function isSubMenu<ValueType extends string>(item: MenuItem<ValueType>): item is MenuItemSubMenu<ValueType> {
    return 'items' in item;
}

export function isMenuSection<ValueType extends string>(item: MenuItem<ValueType>): item is MenuItemSection<ValueType> {
    return isSection(item);
}
